import React from 'react';
import { CheckCircle2Icon, GiftIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
import { MOCKUP_URL, bonusList, coreVolumesList } from '../data/content';
const finalChecks = ['6 Action-Focused Clinical Volumes', '5 Practical Documentation Bonuses', 'Immediate Digital Access', 'One-Time Payment', '7-Day Money-Back Guarantee'];
export function Offer() {
  return <section id="offer" className="w-full bg-navy-950 px-4 py-16 md:px-8 md:py-24" data-id="element-212" data-mp="p0js2qlmtlar">
      <div className="mx-auto max-w-3xl" data-id="element-213" data-mp="13xkdydh56m1b">
        <h2 className="text-center font-serif text-[1.85rem] font-extrabold leading-tight text-white sm:text-4xl md:text-5xl" data-id="element-214" data-mp="13ylxl6c84gun">
          Your complete veneer complication workflow is <span className="text-gold-400" data-id="element-215" data-mp="2fb4ykrc5au3y">ready</span>
        </h2>
        <p className="mt-4 text-center text-lg font-bold text-gold-300" data-id="element-216" data-mp="2add7fzjbrc0t">
          Get all 6 clinical volumes + 5 practical bonuses
        </p>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-2xl ring-4 ring-gold-400" data-id="element-217" data-mp="pjfjy9s2ulin">
          <div className="bg-gold-400 px-5 py-3 text-center text-sm font-extrabold uppercase tracking-wider text-navy-900" data-id="element-218" data-mp="ui0o2kag9pcd">
            The complete digital collection
          </div>
          <div className="px-5 py-8 sm:px-10" data-id="element-219" data-mp="13iysh3osvyvh">
            <img src={MOCKUP_URL} alt="Complete Veneer Complications Blueprint collection" className="mx-auto w-full max-w-md" data-id="element-220" data-mp="13hnop3vcur4d" />

            <h3 className="mt-8 text-lg font-extrabold text-navy-900" data-id="element-221" data-mp="bsasvw2rz1jx">Your 6 core volumes:</h3>
            <ul className="mt-3 space-y-2.5" data-id="element-222" data-mp="ftvzizopujlo">
              {coreVolumesList.map(v => <li key={v} className="flex gap-2.5 text-base text-ink" data-id="element-223" data-mp="kkvx875nt5p8">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-224" data-mp="kn8juxmd448m" />
                  {v}
                </li>)}
            </ul>

            <h3 className="mt-7 text-lg font-extrabold text-navy-900" data-id="element-225" data-mp="3o8eezmgzl1fb">Plus your 5 practical bonuses:</h3>
            <ul className="mt-3 space-y-2.5" data-id="element-226" data-mp="vdnwio48m198">
              {bonusList.map(b => <li key={b} className="flex gap-2.5 text-base text-ink" data-id="element-227" data-mp="qg4h3kvszifp">
                  <GiftIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-228" data-mp="154ili08vbeyd" />
                  {b}
                </li>)}
            </ul>

            <div className="mt-8 border-t border-navy-900/10 pt-8 text-center" data-id="element-229" data-mp="cgmth8u8ub7x">
              <p className="text-base font-bold uppercase tracking-wide text-navy-900" data-id="element-230" data-mp="7hrxf579mq5v">Everything included for just</p>
              <p className="mt-1 flex items-baseline justify-center gap-2" data-id="element-231" data-mp="li2oo9chm6rk">
                <span className="font-serif text-7xl font-extrabold text-navy-900" data-id="element-232" data-mp="lf884swlh63f">$27</span>
                <span className="text-xl font-bold text-muted" data-id="element-233" data-mp="hic3qm9n6kuy">USD</span>
              </p>
              <p className="mt-2 text-base font-semibold text-emerald-700" data-id="element-234" data-mp="1wysz64ny1kqz">One payment. Complete digital access.</p>
              <p className="mt-2 text-sm text-muted" data-id="element-235" data-mp="20enhmc6z3int">
                No recurring subscription. No additional payment required to access the six core volumes
                and five included bonuses.
              </p>

              <div className="mt-6 flex flex-col items-center gap-4" data-id="element-236" data-mp="1qgzlbhtpy33j">
                <CTAButton size="xl" label="Yes! I Want My Veneer Complication Decision Map" data-id="element-237" data-mp="1qiu9d50aebbu" />
                <CountdownTimer data-id="element-238" data-mp="1vhdw37mpfr59" />
                <ScarcityBar data-id="element-239" data-mp="2j4lqguilhfsi" />
                <p className="flex max-w-xl items-start justify-center gap-2 rounded-xl bg-navy-100 px-4 py-3 text-left text-sm font-medium text-navy-900" data-id="element-240" data-mp="2j6gdqfhc9jzr">
                  <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-700" aria-hidden="true" data-id="element-241" data-mp="29fll8tdi1o5v" />
                  Currency conversion is automatic — at checkout, the price is shown in your local
                  currency.
                </p>
              </div>

              <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-242" data-mp="321wm8550pr37">
                {finalChecks.map(c => <li key={c} className="flex items-center gap-1.5 text-sm font-semibold text-navy-900" data-id="element-243" data-mp="1j64pf1m88ttn">
                    <CheckCircle2Icon className="h-4 w-4 text-emerald-600" aria-hidden="true" data-id="element-244" data-mp="1e7l4n4jddo2v" />
                    {c}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}